import { GridRowModel } from '@mui/x-data-grid';
import { CustomForm } from './CustomForms/types';
import { FormPortalWithLinkedTenants } from './Portals/types';

/**
 * Returns the input text with every word first letter capitalized
 *
 * @param str - The input text
 * @returns The input text with every word first letter capitalized
 *
 */
export const capitalize = (str: string): string => {
    const words = str.split(' ');
    let capitalized = '';
    words.forEach((word) => {
        capitalized += ` ${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
    });
    return capitalized.trim();
};

export const validateFormPortalViewNames = (
    name: string,
    rows: CustomForm[] | FormPortalWithLinkedTenants[] | GridRowModel[],
    view: 'Form' | 'Portal' | 'View'
): string => {
    if (rows.some((row) => row.name.toLowerCase().trim() === name.toLowerCase().trim())) return `${view} name must be unique`;
    if (/[#$%@]/.test(name)) return `${view} names can only contain letters, numbers, and spaces`;
    if (name.length > 50) return `${view} names cannot exceed 50 characters`;
    return '';
};

const FIELD_NAME_MAPPING: { [key: string]: string } = {
    createdAt: 'createdOn',
    receivedAt: 'receivedOn',
    updatedAt: 'updatedOn',
    approvedAt: 'approvedOn'
};
export const adjustFieldNames = (name: string) => FIELD_NAME_MAPPING[name] || name;
